export const zh = {
  hanab: "华火",
  welcome: "欢迎",
  newGame: "新游戏",
  nextGame: "再来一局",
  tagline: "和朋友一起在线玩华火！",
  subTagline: "多人合作卡牌游戏，支持手机、平板和电脑",
  createRoom: "创建房间",
  joinRoom: "加入房间",
  rejoinGame: "重进房间",
  whatsHanab: "华火是？",
  invitationByPlayers: "{{playerNames}} 邀请你来一局华火 🎉",
  invitationByPlayers_plural: "{{playersNames}} 邀请你来一局华火 🎉",
  invitationNoPlayers: "有人邀请你来一局华火 🎉",
  gameFull: "人齐了！",
  gameNotFull: "{{count}} / {{playersCount}} 已加入",
  gameNotFull_plural: "{{count}} / {{playersCount}} 已加入", // necessary in French
  startGame: "开始游戏",
  addAi: "+ 添加AI",
  lobby: "大厅",
  choosePlayerName: "选择你的角色名",
  join: "加入",
  autoplay: "自动出牌",
  shareGame: "分享房间",
  copy: "复制",
  waitForOthers: "等待其它玩家，或者",
  gameStarted: "游戏已开始！",
  gameStarts: "游戏开始！",
  discardPile: "弃牌堆 ({{ discardLength }})",
  preventLossContent: "你失误了。确定继续吗？",
  rewind: "🕑 回放",
  backToGame: "返回游戏",
  theirTurn: "{{currentPlayerName}} 的回合!",
  go: "Go", // Natural to mix with Chinese
  estimatedMaxScore: "这摞牌预计最高分数：{{reachableScore}}.",
  keepPracticing: "继续努力吧",
  congrats: "做得好！",
  hideStats: "隐藏统计",
  showStats: "显示统计",
  gameOver: "游戏结束！• 你们的分数是 {{playedCardsLength}} 🎉",
  score: "华火 • 分数：{{score}} / {{maxPossibleScore}}",
  turnsLeftDisclaimer: "· 还剩 1 回合",
  turnsLeftDisclaimer_plural: "· 还剩 {{count}} 回合",
  cardLeft: "还剩 {{pileLength}} 张",
  tokens: "指示物",
  deck: "牌库",
  loading: "加载中...",
  menu: "主菜单",
  tutorial: "界面导览",
  rules: "规则",
  yourTurn: "你的回合",
  youWillStart: "从你先开始",
  hide: "隐藏",
  reveal: "展示",
  cardSelected: "选择 {{position}} 位的牌",
  eightTokens: "8 个指示物",
  cannotDiscard: "你不能弃牌",
  noTokens: "没有指示物，不能提示。",
  selectVignette: "选择一个颜色或数字给出线索",
  hint: "提示",
  negativeHintColor: "你没有 {{ color }} 色的牌",
  negativeHintNumber: "你没有 {{ number }}",
  positiveHintColor: "你的 {{ positions }} 牌是 {{ color }} 色的",
  positiveHintNumber: "你的 {{ positions }} 牌是 {{ number }}",
  positiveHintNumberSequence: "你的 {{ positions }} 牌是 {{ number }} 或以上",
  positiveHintColor_plural: "你的 {{ positions }} 牌是 {{ color }} 色的",
  positiveHintNumber_plural: "你的 {{ positions }} 牌是 {{ number }}",
  positiveHintNumberSequence_plural: "你的 {{ positions }} 牌是 {{ number }} 或以上",
  you: "你",
  hinted: "提示",
  played: "打出",
  discarded: "弃牌",
  rollback: "回滚",
  rollbackDisclaimer: "你即将回滚至上一个行动！",
  cannotRollback: "现在不能回滚",
  abort: "终止",
  introTutorial: "教程",
  introContent: "让我们简单浏览一下界面！",
  playedCardsTutorial: "已打出卡牌",
  playedCardsTutorialContent: "这里是已打出的牌待的地方。\n每种颜色打到 5 以赢得游戏。",
  discardTutorial: "弃牌堆",
  discardTutorialContent: "这里是你和队友弃掉的牌。\n避免把完成游戏所需的牌给弃掉。",
  yourGameTutorial: "你的游戏区",
  yourGameTutorialContent: "这些是你的牌。\n你看不见你的牌，但其他玩家可以，并会给你相关线索。",
  teammatesTutorial: "队友",
  teammatesTutorialContent: "这些是你的队友。\n像你一样，他们也看不见自己的牌。\n给出线索，帮助他们打出或弃掉某些牌。",
  hintTokensTutorial: "线索指示物",
  hintTokensTutorialContent:
    "有些行动需要代价。\n\n- 进行提示消耗1个线索指示物。\n- 弃掉一张牌增加一个线索指示物。\n- 打出 5 会得到1个线索指示物奖励。",
  strikeTokensTutorial: "爆炸指示物",
  strikeTokensTutorialContent:
    "打出错误的牌会使它被弃掉，并且惩罚1个爆炸指示物。\n爆炸指示物达到3个时，你们当即输掉这局游戏。",
  yourTurnTutorial: "现在是你的回合",
  yourTurnTutorialContent:
    "你有3个选项：\n\n- 点击你的游戏区打出一张牌...\n- ... 或弃掉它\n- 点击一个队友的游戏区来进行提示。",
  skip: "✕ 跳过",
  offline: "你已离线！",
  apologies: "很抱歉，发生了一些问题 😕",
  errorWillInvestigate: "我们会尽快调查。请<1>联系我们</1>，让我们知道发生了什么。",
  earlyDevelopment: "本游戏还在早期开发阶段，欢迎你的反馈。",
  publicRepo: "如果你想为本项目贡献或提交Bug，我们也有<1>公共Github仓库</1>。",
  backMenu: "返回主菜单",
  landingImageAlt: "华火在线游戏图标",
  classicVariant: "经典",
  orangeVariant: "橙色",
  multicolorVariant: "多彩",
  rainbowVariant: "彩虹",
  criticalRainbowVariant: "困难彩虹",
  sequenceVariant: "序列",
  classicVariantDescription: "经典5色华火游戏",
  multicolorVariantDescription: "加入第六种颜色，每个数字只有一张",
  rainbowVariantDescription: "加入第六种彩虹色，会在任何颜色的线索中被标记",
  criticalRainbowVariantDescription: "彩虹模式，但每个数字只有一张",
  orangeVariantDescription: "加入第六种颜色",
  sequenceVariantDescription: "数字线索也会标记比它更大的数字牌",
  showDirectHints: "显示直接提示",
  hideDirectHints: "不显示提示",
  botSpeed: "AI速度",
  normalGameExplanation: "分享链接，即可与朋友在线游玩。",
  passandplayExplanation: "在“击鼓传花”模式中，你可以和多名同处一室的线下玩家一起游玩，把设备传递给每个玩家以进行回合",
  private: "私人房间",
  hints: "提示",
  allowRollback: "允许回滚",
  preventLoss: "防止失误",
  passandplay: "击鼓传花",
  passandplaySubtext: "在现实中把设备传递给每个玩家以进行回合",
  privateSubtext: "你的游戏不会显示在 “加入房间” 区域",
  advancedOptions: "高级选项",
  players: "玩家",
  mode: "模式",
  seed: "种子",
  objective: "游戏目标",
  rulesIntro:
    "华火是Antoine Bauza制作的卡片游戏。游戏是合作性质的，玩家不是互相对立，而是一起完成一个共同的目标。玩家扮演粗心的的烟火师，不小心把他们为一场盛大的烟火表演准备的火药、引线和外壳都混在了一起。表演马上就要开始了，但场面有些混乱。为了防止表演变成灾难，他们需要互相帮助。",
  rulesGoal:
    "烟火师团队的目标是通过按升序组合同种颜色的数字卡牌（1、2、3、4、5），燃放5种颜色的烟火（白、红、蓝、黄、绿）。",
  rulesSetupTitle: "游戏设置",
  rulesSetup:
    "本应用已经设置好了一切游戏所需，非常方便 😉。游戏开始时，你们有8个蓝色指示物 - 线索指示物 - 和3个红色指示物 - 爆炸指示物。\n\n牌库由50张卡牌组成，每个颜色10张，<1>包含数字 1、1、1、2、2、3、3、4、4、5</1>。\n· 2到3人游戏中，给每个玩家发5张牌\n· 4到5人游戏中，给每个玩家发4张牌。\n\n注意，玩家不允许查看自己的手牌！",
  rulesGameTitle: "进行游戏",
  rulesGame:
    "在每个玩家的回合中，他们会进行以下三个行动中的一个（且仅一个）行动。你不能跳过你的回合。\n\n1. 给另一个玩家提供线索。\n2. 弃掉一张牌。\n3. 打出一张牌\n\n玩家不能在其他人的回合给出线索或建议！",
  rulesHintTitle: "1. 提供线索",
  rulesHint:
    "当你以线索进行提示，首先移除一个蓝色指示物。注意：如果你们没有蓝色指示物，你就不能进行提示，只能选择其他行动。\n\n然后点击一个玩家的手牌来提供关于那些手牌的线索。你可以告诉这个玩家这些牌属于一个（且仅一个）颜色或一个（且仅一个）数字。",
  rulesDiscardTitle: "2. 弃掉一张牌",
  rulesDiscard:
    "弃掉一张牌返还一个蓝色指示物。你可以点击自己的手牌来把它弃掉。然后你从牌库抽一张牌加入到你的手牌。\n注意：如果你们有8个蓝色指示物，你就不能弃牌，只能选择其他行动。你随时可以查看弃牌堆。",
  rulesPlayTitle: "3. 打出一张牌",
  rulesPlay:
    "在你的回合，可以从你的手牌中拿出一张牌打出。\n有以下两种情况：\n· 如果这张牌可以开始或继续一个烟火，它会被加入到那个烟火的牌堆\n· 如果这张牌不能加入烟火牌堆，弃掉这张牌，增加一个红色指示物\n然后，从牌库抽一张新牌\n\n当玩家打出一张5来完成对应的烟火时，返还一个蓝色指示物作为奖励。如果所有蓝色指示物都还在，则不会获得奖励",
  rulesEndTitle: "游戏终盘",
  rulesEnd:
    "华火有三种结束方式：\n· 如果拿到3个红色指示物，你们输掉这局游戏，你们的烟火表演付之一炬！\n· 如果玩家以 5 完成了所有颜色的烟火，你们的团队的烟火绚烂收尾，你们获得了最高分数25分 - 如果开启多彩选项，则是30分！\n· 如果玩家抽走了牌库的最后一张牌，游戏会很快结束。每个玩家还有一个回合，包括抽走最后一张牌的玩家。玩家在最终回合中无法抽取额外卡牌。\n\n然后，所有玩家根据他们组装烟火的情况得分。",
  rulesExtensionTitle: "扩展",
  rulesExtensionMulticolor:
    "🎨 多彩扩展增加了第6种烟火和第6套牌，每个数字一张：1、2、3、4、5。所以这些烟火更加珍稀，你必须小心不要弃掉它们。规则不变，但你只有完成全部6堆烟火才能达到最高分数30分。",
  rulesExtensionRainbow:
    "🌈 彩虹扩展也增加了第6种烟火，和其它5种有一样的牌（三张1、2两张2/3/4和一张5）。特殊之处在于，彩虹牌有所有的颜色。每次你给出颜色线索时，它们都会被标记。",
  rulesUsTitle: "我们是？",
  rulesUs:
    "我们是几个桌游爱好者。在2020居家期间，我们想要找一个远程一起玩的替代方案。\n因为我们既喜欢写代码、又爱玩华火，我们决定做一个移动端友好的在线版华火。\n\n👉 如果你也喜欢这个游戏，请像我们一样购买<2>实体版</2>来支持其创作者！",
  howToContribute: "如何贡献？",
  rulesContact: "✉️ 如果你有任何问题或建议，<1>联系我们</1>",
  rulesContributeRepo: "💻 如果你想要为本项目贡献，我们也有<1>公共Github仓库</1>。",
  rulesDiscordServer: "🗣 加入我们的Discord服务器来讨论新的功能和改进",
  rulesBuymeacoffee: "🙇‍♀️ 你也可以“给我们买杯咖啡”，支持我们并承担一部分服务器费用",
  noRoom: "没有可用房间",
  faster: "很快",
  fast: "快",
  slow: "慢",
  discard: "弃牌",
  play: "打出",
  green: "绿",
  red: "红",
  yellow: "黄",
  blue: "蓝",
  white: "白",
  multicolor: "彩",
  orange: "橙",
  green_plural: "绿",
  red_plural: "红",
  yellow_plural: "黄",
  blue_plural: "蓝",
  white_plural: "白",
  multicolor_plural: "彩",
  orange_plural: "橙",
  summary: "总结",
  summarySubtitle: "这局华火",
  gameCompleted: "游戏耗时 {{ gameDuration }}",
  result: "游戏结果",
  evolution: "游戏历程",
  evolutionSubtext:
    "查看游戏每一步的历史记录！每个玩家的卡牌上会显示它们是否可以打出、可以弃掉或者是危险牌（如果弃掉就会降低最高可能获得分数的牌，比如彩色牌或者一张5）。",
  playerActions: "各玩家行动数",
  playHints: "每线索平均打出数：<1>{{playsPerHint}}</1>",
  playerHints: "谁给出最多线索？",
  tryOutTitle: "我来试试！",
  tryOutButton: "尝试这摞牌",
  tryOutAlternative: "在<1>hanab.cards</1>上，你还可以游玩其它设置以及与AI对局",
  back: "返回",
  start: "开始！",
  statsPlayable: "可打",
  statsDiscardable: "可弃",
  statsDangerous: "危险",
  statsTurnCard: "这张牌在那一回合是",
  statsTurnAction: "那一回合玩家的行动",
  showInsights: "显示描述",
  showCards: "显示卡牌",
  started: "先开始",
  youGaveHintTurn: "你提示了<1></1>的<3></3>",
  youDiscardedTurn: "你弃掉了<1></1>",
  youPlayedStrikeTurn: "你引起了<1>爆炸</1>，因为打出了<3></3>", //awkward, <3> must be the last
  youPlayedTurn: "你打出了<1></1>",
  somebodyHintedYouTurn: "<0></0>提示了你的<2></2>",
  somebodyHintedSomebodyTurn: "<0></0>提示了<2></2>的<4></4>",
  somebodyDiscardedTurn: "<0></0>弃掉了<2></2>",
  somebodyPlayedTurn: "<0></0>打出了<2></2>",
  somebodyPlayedStrikeTurn: "<0></0>引起了<2>爆炸</2>，因为打出了<4></4>", //awkward, <4> must be the last
  whatYouDrewTurn: "然后抽到了<1></1>",
  whatTheyDrewTurn: "然后抽到了<1></1>",
  selectLanguage: "选择语言",
  creatingGame: "创建游戏中...",
  partySetup: "玩家：{{players}} · 模式：{{variant}} · 随机 #{{shuffle}}",
  sendMessagePlaceholder: "给队友发送信息",
  sendMessage: "发送",
  message: "<0></0>：<1></1>",
  colorBlindMode: "色盲模式",
  colorBlindModeSubtext: "在卡牌上显示图形以辅助辨别颜色",
  pageNotFound: "找不到网页",
  contributeLanguage: "为项目贡献！",
  buymeacoffeePostGame: "支持本游戏。<2>给我们买杯咖啡</2>",
  next: "下一步",
  new: "New", // Natural to use in Chinese UI
  learnHanab: "了解规则",
  learnHanabTime: "~5 分钟",
  learnWhileWaiting: "在等待期间，顺便了解华火规则",
  learnHanabEnglish: "了解华火 - ",
  learn: {
    welcome: {
      title: "5分钟了解华火",
      1: "欢迎你！在这个简单教学中，你将独立完成一局游戏。",
      2: "别担心，我们会一路引导你的！",
    },
    cooperation: {
      title: "合作",
      1: "华火是一个合作游戏。\n\n你和其它玩家会完成一个共同目标。",
    },
    colorBlind: {
      label: "你有辨色问题吗？开启色盲模式",
    },
    cards: {
      title: "卡牌",
      1: {
        1: "卡牌有数字",
        2: "到",
        3: "和颜色",
        4: "或",
      },
      2: "在每局游戏开始，每个玩家抽5张牌。",
      3: "你看不到自己的牌，但能看到别人的牌。",
    },
    goal: {
      title: "目标",
      1: "作为一个团队，打出每个颜色的所有牌。",
      2: "每个颜色的牌堆必须按照数字升序打出。",
      3: "比方说，在上面的例子中，你必须先打",
      4: "再打",
      5: "。",
    },
    actions: {
      title: "行动",
      0: "在你的回合，你可以选择执行3个行动中的一个",
      play: {
        title: "1. 打出",
        1: "从你的手牌打出一张牌到版面上。",
        2: "你过你的牌不能成功打出，这张卡被弃掉，并且你的获得一个爆炸指示物：",
        3: "从牌库抽一张牌。",
      },
      hint: {
        title: "2. 提示",
        1: "给一个队友的手牌进行标示。",
        2: "进行提示消耗一个线索指示物：",
        3: "你可以提示一种颜色或者一个数字。",
        4: "比方说，在下面这手牌中：",
        5: "你可以提示以下几种信息：",
        6: "你的 A 和 B 是蓝色的",
        7: "你的 A 和 C 是 2",
        8: "你的 E 是黄色的",
        9: "你没有绿色的牌",
      },
      discard: {
        title: "3. 弃牌",
        1: "从你手中丢弃一张牌。它将永远消失。",
        2: "获得一个线索指示物：",
        3: "从牌库抽一张牌。",
      },
    },
    tokens: {
      title: "指示物",
      1: "线索指示物用来进行提示。",
      2: "在游戏开始，你们团队有8个线索指示物.",
      3: "当有人打出不可打出的牌是，获得爆炸指示物。",
      4: "达到3个爆炸指示物时，你们当即输掉这局游戏。",
    },
    ready: {
      title: "准备好了？",
      1: "让我们马上开始一局试试看！",
      2: "华火有着无限的选择和可能。过程中没有唯一正确的选项。",
      3: "这个教程试图帮你理解你和你的朋友能用上的一种基本游戏风格。",
      4: "接下来会提到的约定不是官方规则，只是一些玩家创建的更有效率的系统。如果你想自己探索，你可以离开教程并且马上开始游戏。",
    },
  },
  tutorialActions: {
    beginning: {
      content:
        "游戏开始时，你对你的手牌一无所知，所以弃牌或打出可能有危险。给出线索比较安全。Adam有两张能打出的牌：<3/>和<5/>。让我们告诉他，提示他的 1。",
      todo: "点击Adam的游戏区，选择<1/>，然后点击“提示”",
    },
    playFirstRed: {
      content:
        "很好！Adam根据你给的线索打出了他的第一张牌。\nJane也在你的2张牌上提示了<3/>。这可能说明这些牌现在就能打。\n<6>约定：最左原则</6>当“打出”线索标记多张卡牌，那就假设最左边那张是想让人打的。",
      todo: "选择你的游戏区，打出你的第二张牌",
    },
    playSecondRed: {
      content:
        "好的。现在我们还知道第三张牌也是红的。\n<2>约定：乐观假定</2>当多张牌被线索标记，那就假设它们能按从左到右的顺序打出。如果不是这样，相信队友会给出“停止”线索来制止我们犯错。\n让我们乐观地假设第三张牌是<6/>。",
      todo: "选择你的游戏区，打出你的第三张牌",
    },
    hint: {
      content:
        "我们现在对手牌一无所知，并且只剩4个线索<1/>了。\n\nAdam知道他的第三张牌是蓝的。如果你提示Jane的<6/>，然后她把它打出，Adam就能明白他可以打出<8/>。",
      todo: "点击Jane的游戏区，提示她的<1/>",
    },
    interpret: {
      content:
        "嗯……看起来Adam没理解你的意思。不过没关系，至少没造成失误。\n我们得到一个<3/>的线索。你能猜到它是什么意思吗？",
      todo: "解读你得到的线索😉",
    },
    discard: {
      content:
        "目前进展顺利，你们已经打出了8张牌。但是线索已经所剩不多，这样很快就会陷入困境。要获得更多线索，你只能开始弃牌了。\n<2>约定：最右弃牌</2>弃牌有风险，你可能不小心弃掉一张重要的牌让游戏陷入困境。每次弃牌都应该弃掉你最右边的未知牌，因为它是最老的那张。如果它被弃掉会有风险的话，你的队友应该有足够的时间告诉你。\n",
      todo: "弃掉你最右的牌",
    },
    play: {
      content: "看来你的队友有点大手大脚。现在你们没有线索了，他们下回合大概率只能弃牌了。\n",
      todo: "打出你的第一张牌",
    },
    save: {
      content:
        "😅 Adam把<1/>弃掉了。每个颜色的<3/>在牌库里只有一张，千万别弃掉它！\n\n根据<8>最右弃牌</8>约定，我们应该能够预见这次弃牌的。Adam的最后一张牌上有标记，所以他会选择弃掉前面的<10/>。\n\n时刻留心你的队友接下来可能会做什么！",
      todo: "提示Jane她的<1/>",
    },
  },
  tutorialComplete:
    "就到这里吧！你已经为游戏做好准备了。你可以继续这局或者和朋友开一局新游戏！\n\n感谢你的参与🎉\n\n你可以点击 ☰ 按钮查看完整规则和界面导览。",
};
